import SendAsUrgentImage from '@shared/assets/images/v2/send-as-urgent.svg';
import { Button } from '@shared/components/Button';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { i18n } from '@shared/util/i18n';
import { Styles } from '../styles';
import styles from './content.module.css';

export interface UrgentModalContentProps {
  count: number;
  onClose(): void;
  onRemoveSendAsUrgent(): void;
}

export function UrgentModalContent({
  count,
  onClose,
  onRemoveSendAsUrgent,
}: UrgentModalContentProps) {
  return (
    <View padding={3} gap={3} className={styles.urgentModalContent}>
      <MBImage style={Styles.urgentImage} source={SendAsUrgentImage} />

      <View gap={2}>
        <Text balance>
          <Text weight="bold">{i18n('chat.modal.urgent.message.start', { count })}</Text>
          {i18n('chat.modal.urgent.message.end')}
        </Text>
        <Text size="body2" inactive balance>
          <Text weight="bold" size="body2">
            {i18n('chat.modal.urgent.proTip.start')}
          </Text>
          {i18n('chat.modal.urgent.proTip.end')}
        </Text>
      </View>

      <View row center gap={1}>
        {!!count && (
          <Button
            variant="secondary"
            label={i18n('chat.modal.urgent.removeSendAsUrgent')}
            onClick={onRemoveSendAsUrgent}
          />
        )}
        <Button variant="primary" label={i18n('common.gotIt')} onClick={onClose} />
      </View>
    </View>
  );
}
